import { render, staticRenderFns } from "./PageLikedContent.vue?vue&type=template&id=7c66f37c&"
import script from "./PageLikedContent.vue?vue&type=script&lang=ts&"
export * from "./PageLikedContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports